package com.essntl.features.tag.ui.alltags

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.getData
import com.essntl.features.tag.domain.repository.TagRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update
import kotlin.collections.orEmpty
import kotlin.collections.plus

class AllTagsViewModel(
    val tagRepository: TagRepository,
    private val state: MutableStateFlow<AllTagsState>,
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {

    fun onEvent(event: AllTagsEvent) {
        when (event) {
            is AllTagsEvent.GetAllTags -> getAllTags()
            is AllTagsEvent.AddTag -> addTag(event)
            is AllTagsEvent.EditTag -> editTag(event)
            is AllTagsEvent.DeleteTag -> deleteTag(event)
        }
    }

    private fun getAllTags() =
        getData(
            getData = { tagRepository.getAll() },
            getState = { state.value.getAllTags },
            setState = { newState -> state.update { it.copy(getAllTags = newState) } },
        )

    private fun addTag(event: AllTagsEvent.AddTag) =
        state.update {
            it.copy(
                getAllTags = it.getAllTags.copy(
                    data = it.getAllTags.data.orEmpty() + event.t,
                ),
            )
        }

    private fun editTag(event: AllTagsEvent.EditTag) =
        state.update {
            it.copy(
                getAllTags = it.getAllTags.copy(
                    data = it.getAllTags.data
                        .orEmpty()
                        .map { t ->
                            if (t.id == event.t.id) event.t else t
                        },
                ),
            )
        }

    private fun deleteTag(event: AllTagsEvent.DeleteTag) =
        state.update {
            it.copy(
                getAllTags = it.getAllTags.copy(
                    data = it.getAllTags.data
                        .orEmpty()
                        .filter { t ->
                            t.id != event.t.id
                        },
                ),
            )
        }
}